// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2I_WF","list":"PatternAutocomplete_list__1deiN"};